import axios from '../request'
export default{
    getpaper(param){//获取报纸信息
        return axios({
            url:'/paper.php?',
            method:'get',
            params:{
                ...param,
                type:process.env.VUE_APP_TYPE
            }
        })
    },
    gethasday(){//获取日期范围
        return axios({
            url:'/paper.php?job=GetHasDay',
            methods:'get',
            params:{
                type:process.env.VUE_APP_TYPE
            }
        })
    },
    getarticle(param){//获取新闻详情
        return axios({
            url:'/GetPaperForArticle.php',
            methods:'get',
            params:{
                ...param,
                type:process.env.VUE_APP_TYPE
            }
        })
    }
}